<template>
	<q-field :error="yearInvalid" :error-label="yearErrorLabel" :helper="yearHint">
		<q-input
			:dark="dark"
			color="secondary"
			v-model="academicYear"
			type="number"
			:float-label="yearLabel"
			:min="minAllowed"
			:max="maxAllowed"
			:step="1" />
	</q-field>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapMutations } from 'vuex';
import LearningEntry from '@/models/LearningEntry';
import config from '@/models/services/config';
import { isYearValid, minYearAllowed, maxYearAllowed } from '@/models/validation/IValidator';

@Component({
	methods: mapMutations('wmct', {
		updateLearningYear: 'UPDATE_LEARNING_YEAR',
	}),
})
export default class YearSelector extends Vue {
	@Prop() public value!: LearningEntry;

	public get dark() {
		return config.Dark;
	}

	private updateLearningYear!: ({ learning, year }: { learning: LearningEntry, year: number | null }) => void;

	private get validating() {
		return this.value.isValidating;
	}

	public get yearLabel(): string {
		return 'Year';
	}

	public get academicYear() {
		return this.value.academicYear;
	}

	public set academicYear(year: number | null) {
		this.updateLearningYear({ learning: this.value, year });
	}

	public get yearInvalid(): boolean {
		if (this.validating || this.value.academicYear != null) {
			return !isYearValid(this.value.academicYear);
		}

		return false;
	}

	public get minAllowed(): number | null {
		return minYearAllowed();
	}

	public get maxAllowed(): number | null {
		return maxYearAllowed();
	}

	public get yearErrorLabel(): string {
		const min = this.minAllowed;
		const max = this.maxAllowed;
		return (min === null && max === null) ? ''
				: `Please enter a ${this.yearLabel} between ${min} and ${max}`;
	}

	public get yearHint(): string {
		const min = this.minAllowed;
		const max = this.maxAllowed;
		return (min === null && max === null) ? ''
				: `Enter a ${this.yearLabel} between ${min} and ${max}`;
	}
}
</script>
